import {
    COMPATIBILITY_COLUMNS,
    ID_TYPE,
    MODEL_COLUMNS,
    ROUTES,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    useWindowLocation
} from "../../shared";
import CloneModelInline from "../Actions/dialogs/DeviceModels/Inline/CloneModelInline";
import EditCompatibilityInline from "../Actions/dialogs/DeviceModels/Inline/EditCompatibilityInline";
import EditModelInline from "../Actions/dialogs/DeviceModels/Inline/EditModelInline";
import {
    useCompatibilitiesInlineActions,
    useModelsInlineActions
} from "../Actions/InlineActions";
import { DEVICE_MODEL_ACTIONS } from "../Actions/types";
import MainContainer from "../MainContainer";
import Table, { TabFilters } from "../Table";

const DeviceModels = () => {
    const {
        compatibilityInlineActions,
        compatibilityRowData,
        isEditCompatibilityOpen,
        closeCompatibilityEditDialog
    } = useCompatibilitiesInlineActions();

    const {
        modelInlineActions,
        modelRowData,
        isCloneModelOpen,
        isEditModelOpen,
        closeModelDialog
    } = useModelsInlineActions();

    const { pathname } = useWindowLocation();

    const isModelsTab = pathname === ROUTES.DeviceModels;

    const tabs = [
        { label: TABLE_NAMES.DeviceModels, route: ROUTES.DeviceModels },
        {
            label: TABLE_NAMES.DeviceModelTaskCompatibilities,
            route: ROUTES.DeviceModelTaskCompatibilities
        }
    ];

    return (
        <>
            <MainContainer>
                <Table
                    key={
                        isModelsTab
                            ? TABLE_NAMES.DeviceModels
                            : TABLE_NAMES.DeviceModelTaskCompatibilities
                    }
                    name={
                        isModelsTab
                            ? TABLE_NAMES.DeviceModels
                            : TABLE_NAMES.DeviceModelTaskCompatibilities
                    }
                    nameForFilters={
                        isModelsTab
                            ? TABLE_NAMES_WITH_FILTERS.DeviceModels
                            : TABLE_NAMES_WITH_FILTERS.DeviceModelTaskCompatibilities
                    }
                    initialColumns={
                        isModelsTab ? MODEL_COLUMNS : COMPATIBILITY_COLUMNS
                    }
                    inlineActions={
                        isModelsTab
                            ? modelInlineActions
                            : compatibilityInlineActions
                    }
                    idType={ID_TYPE.Id}
                    sortFromNewest={isModelsTab}
                    hasActionBar
                    isNotSelectable={!isModelsTab}
                    tabFilters={<TabFilters tableName={pathname} tabs={tabs} />}
                />
            </MainContainer>

            <CloneModelInline
                data={modelRowData}
                isOpen={isCloneModelOpen}
                close={() => closeModelDialog(DEVICE_MODEL_ACTIONS.CloneModel)}
            />

            <EditModelInline
                data={modelRowData}
                isOpen={isEditModelOpen}
                close={() => closeModelDialog(DEVICE_MODEL_ACTIONS.EditModel)}
            />

            <EditCompatibilityInline
                data={compatibilityRowData}
                isOpen={isEditCompatibilityOpen}
                close={closeCompatibilityEditDialog}
            />
        </>
    );
};

export default DeviceModels;
